







































import { Component, Vue, Prop } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';
import VoucherDetail from "@/shared/components/VoucherDetail.vue";
const moment = require('moment');
@Component({
    components: {
        'voucher-detail': VoucherDetail
    }
})
export default class ListVoucher extends Vue {
    @Prop({default: {}})
    private vouchers: any;
    private voucherDetailPopup = false;
    private voucher_details: any;
    private voucher_code: any;
    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private viewDetail(item: any) {
        this.voucher_details = item.Details;
        this.voucher_code = item.Code;
        if(this.voucher_details.length > 0) {
            this.voucherDetailPopup = true;
        }
    }
}
